module.exports = __webpack_public_path__ + "img/tag_cg@2x.13a2734d.svg";